import { useNavigate, NavigateOptions, useLocation } from "react-router";

export const useSmartNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const smartNavigate = (to: string | number, options?: NavigateOptions) => {
    if (typeof to === "number") {
      // Handle navigate(-1), navigate(1), etc.
      if (to < 0) {
        // Going back - check if current page has internal navigation state
        const hasInternalState = location.state?.fromInternal === true;

        if (!hasInternalState) {
          navigate("/");
        } else {
          window.history.go(to);
        }
      } else {
        // Going forward - use history API
        window.history.go(to);
      }
    } else {
      // Normal string-based navigation - add internal state
      const enhancedOptions: NavigateOptions = {
        ...options,
        state: {
          ...options?.state,
          fromInternal: true, // Mark this as internal navigation
        },
      };
      navigate(to, enhancedOptions);
    }
  };

  return smartNavigate;
};
